import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

function Badge({ label, color }) {
  return (
    <span style={{ background: `${color}18`, color, border: `1px solid ${color}44`, borderRadius: 6, padding: '2px 8px', fontSize: 11, fontWeight: 600 }}>
      {label}
    </span>
  );
}

function getRuoloColor(ruolo) {
  if (ruolo === 'admin') return '#ef4444';
  if (ruolo === 'responsabile') return '#f59e0b';
  return '#10b981';
}

const FORM_VUOTO = {
  Nome: '', Cognome: '', email: '', password: '', passwordConfirm: '',
  Telefono: '', Ruolo: 'dipendente', Sede: '', Reparto: '',
  Data_assunzione: '', Attivo: true
};

export default function GestioneUtenti() {
  const { utente } = useAuth();
  const [utenti, setUtenti] = useState([]);
  const [sedi, setSedi] = useState([]);
  const [reparti, setReparti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [vista, setVista] = useState('lista'); // lista | nuovo | modifica
  const [selezionato, setSelezionato] = useState(null);
  const [form, setForm] = useState(FORM_VUOTO);
  const [errore, setErrore] = useState('');
  const [successo, setSuccesso] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    caricaDati();
  }, []);

  useEffect(() => {
    if (form.Sede) {
      const rep = reparti.filter(r => r.field === form.Sede || r.sede === form.Sede);
      if (rep.length > 0 && !rep.find(r => r.id === form.Reparto)) {
        setForm(p => ({ ...p, Reparto: '' }));
      }
    }
  }, [form.Sede]);

  const caricaDati = async () => {
    try {
      const [u, s, r] = await Promise.all([
        axios.get(`${API}/utenti?perPage=100`),
        axios.get(`${API}/sedi`),
        axios.get(`${API}/reparti`)
      ]);
      setUtenti(u.data.items || []);
      setSedi(s.data || []);
      setReparti(r.data || []);
    } catch (e) {
      setErrore('Errore nel caricamento dati');
    } finally {
      setLoading(false);
    }
  };

  const repartiFiltrati = reparti.filter(r =>
    !form.Sede || r.field === form.Sede || r.sede === form.Sede
  );

  const utentiFiltrati = utenti.filter(u => {
    const nome = `${u.Nome || ''} ${u.Cognome || ''} ${u.email || ''}`.toLowerCase();
    return nome.includes(search.toLowerCase());
  });

  const apriNuovo = () => {
    setForm(FORM_VUOTO);
    setErrore('');
    setSuccesso('');
    setVista('nuovo');
  };

  const apriModifica = (u) => {
    setSelezionato(u);
    setForm({
      Nome: u.Nome || '',
      Cognome: u.Cognome || '',
      email: u.email || '',
      password: '',
      passwordConfirm: '',
      Telefono: u.Telefono || '',
      Ruolo: u.Ruolo || 'dipendente',
      Sede: u.Sede || '',
      Reparto: u.Reparto || '',
      Data_assunzione: u.Data_assunzione || '',
      Attivo: u.Attivo !== false
    });
    setErrore('');
    setSuccesso('');
    setVista('modifica');
  };

  const salva = async () => {
    setErrore('');
    setSuccesso('');
    if (!form.Nome || !form.Cognome || !form.email) {
      setErrore('Nome, cognome ed email sono obbligatori');
      return;
    }
    if (vista === 'nuovo' && !form.password) {
      setErrore('La password è obbligatoria per i nuovi utenti');
      return;
    }
    if (form.password && form.password !== form.passwordConfirm) {
      setErrore('Le password non coincidono');
      return;
    }
    setSaving(true);
    try {
      if (vista === 'nuovo') {
        await axios.post(`${API}/utenti`, form);
        setSuccesso('Utente creato con successo!');
      } else {
        const dati = { ...form };
        if (!dati.password) { delete dati.password; delete dati.passwordConfirm; }
        await axios.patch(`${API}/utenti/${selezionato.id}`, dati);
        setSuccesso('Utente aggiornato con successo!');
      }
      await caricaDati();
      setTimeout(() => { setVista('lista'); setSuccesso(''); }, 1500);
    } catch (e) {
      setErrore(e.response?.data?.error || 'Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  };

  const toggleAttivo = async (u) => {
    try {
      await axios.patch(`${API}/utenti/${u.id}`, { Attivo: !u.Attivo });
      await caricaDati();
    } catch (e) {
      setErrore('Errore nella modifica');
    }
  };

  if (vista === 'nuovo' || vista === 'modifica') {
    return (
      <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24 }}>
          <button onClick={() => setVista('lista')}
            style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: '8px 12px', color: '#94a3b8', cursor: 'pointer', fontSize: 16 }}>←</button>
          <h2 style={{ color: '#f1f5f9', fontSize: 20, fontWeight: 800, margin: 0 }}>
            {vista === 'nuovo' ? 'Nuovo Dipendente' : 'Modifica Dipendente'}
          </h2>
        </div>

        {errore && <p style={{ color: '#ef4444', fontSize: 13, background: '#ef444418', padding: '10px 14px', borderRadius: 10, marginBottom: 16 }}>{errore}</p>}
        {successo && <p style={{ color: '#10b981', fontSize: 13, background: '#10b98118', padding: '10px 14px', borderRadius: 10, marginBottom: 16 }}>{successo}</p>}

        {[
          ['Nome', 'Nome', 'text'],
          ['Cognome', 'Cognome', 'text'],
          ['Email', 'email', 'email'],
          ['Telefono', 'Telefono', 'text'],
          ['Data Assunzione', 'Data_assunzione', 'date']
        ].map(([label, key, type]) => (
          <div key={key} style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>{label.toUpperCase()}</label>
            <input value={form[key]} onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))} type={type}
              style={{ width: '100%', padding: '11px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box', outline: 'none' }} />
          </div>
        ))}

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>PASSWORD {vista === 'modifica' && '(lascia vuoto per non cambiare)'}</label>
          <input type="password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
            style={{ width: '100%', padding: '11px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box', outline: 'none' }} />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>CONFERMA PASSWORD</label>
          <input type="password" value={form.passwordConfirm} onChange={e => setForm(p => ({ ...p, passwordConfirm: e.target.value }))}
            style={{ width: '100%', padding: '11px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box', outline: 'none' }} />
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>RUOLO</label>
          <select value={form.Ruolo} onChange={e => setForm(p => ({ ...p, Ruolo: e.target.value }))}
            style={{ width: '100%', padding: '11px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box', outline: 'none' }}>
            <option value="dipendente">Dipendente</option>
            <option value="responsabile">Responsabile</option>
            <option value="admin">Admin</option>
          </select>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>SEDE</label>
          <select value={form.Sede} onChange={e => setForm(p => ({ ...p, Sede: e.target.value, Reparto: '' }))}
            style={{ width: '100%', padding: '11px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box', outline: 'none' }}>
            <option value="">Seleziona sede</option>
            {sedi.map(s => <option key={s.id} value={s.id}>{s.Nome}</option>)}
          </select>
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'block', color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>REPARTO</label>
          <select value={form.Reparto} onChange={e => setForm(p => ({ ...p, Reparto: e.target.value }))}
            style={{ width: '100%', padding: '11px 12px', background: '#0f172a', border: '1px solid #334155', borderRadius: 10, color: '#f1f5f9', fontSize: 14, boxSizing: 'border-box', outline: 'none' }}>
            <option value="">Seleziona reparto</option>
            {repartiFiltrati.map(r => <option key={r.id} value={r.id}>{r.Nome}</option>)}
          </select>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, background: '#1e293b', borderRadius: 10, padding: '12px 14px', border: '1px solid #334155' }}>
          <span style={{ color: '#94a3b8', fontSize: 14, flex: 1 }}>Utente attivo</span>
          <div onClick={() => setForm(p => ({ ...p, Attivo: !p.Attivo }))}
            style={{ width: 44, height: 24, borderRadius: 12, background: form.Attivo ? '#10b981' : '#334155', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
            <div style={{ position: 'absolute', top: 2, left: form.Attivo ? 22 : 2, width: 20, height: 20, borderRadius: '50%', background: '#fff', transition: 'left 0.2s' }} />
          </div>
        </div>

        <button onClick={salva} disabled={saving}
          style={{ width: '100%', padding: 14, background: saving ? '#334155' : 'linear-gradient(135deg, #f59e0b, #ef4444)', border: 'none', borderRadius: 12, color: '#0f172a', fontWeight: 800, fontSize: 15, cursor: 'pointer' }}>
          {saving ? 'Salvataggio...' : vista === 'nuovo' ? 'Crea Dipendente' : 'Salva Modifiche'}
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 800, margin: 0 }}>Utenti</h2>
          <p style={{ color: '#64748b', fontSize: 13, margin: '2px 0 0' }}>{utenti.filter(u => u.Attivo).length} attivi · {utenti.length} totali</p>
        </div>
        <button onClick={apriNuovo}
          style={{ background: 'linear-gradient(135deg, #f59e0b, #ef4444)', border: 'none', borderRadius: 12, padding: '10px 14px', color: '#0f172a', fontWeight: 800, cursor: 'pointer', fontSize: 13 }}>
          + Nuovo
        </button>
      </div>

      <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍  Cerca dipendente..."
        style={{ width: '100%', padding: '11px 14px', background: '#1e293b', border: '1px solid #334155', borderRadius: 12, color: '#f1f5f9', fontSize: 14, marginBottom: 16, boxSizing: 'border-box', outline: 'none' }} />

      {errore && <p style={{ color: '#ef4444', fontSize: 13, background: '#ef444418', padding: '10px 14px', borderRadius: 10, marginBottom: 16 }}>{errore}</p>}

      {loading ? (
        <p style={{ color: '#475569', textAlign: 'center', padding: 30 }}>Caricamento...</p>
      ) : utentiFiltrati.length === 0 ? (
        <p style={{ color: '#475569', textAlign: 'center', padding: 30 }}>Nessun utente trovato</p>
      ) : utentiFiltrati.map(u => (
        <div key={u.id} style={{ background: '#1e293b', borderRadius: 14, padding: 14, marginBottom: 8, border: `1px solid ${u.Attivo ? '#334155' : '#1e293b'}`, opacity: u.Attivo ? 1 : 0.5 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: `${getRuoloColor(u.Ruolo)}22`, border: `2px solid ${getRuoloColor(u.Ruolo)}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: getRuoloColor(u.Ruolo) }}>
                {(u.Nome || '?')[0]}{(u.Cognome || '?')[0]}
              </div>
              <div>
                <p style={{ color: '#f1f5f9', fontSize: 15, fontWeight: 700, margin: 0 }}>{u.Nome} {u.Cognome}</p>
                <p style={{ color: '#64748b', fontSize: 12, margin: '2px 0 0' }}>{u.email}</p>
              </div>
            </div>
            <Badge label={u.Ruolo || 'dipendente'} color={getRuoloColor(u.Ruolo)} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => apriModifica(u)}
              style={{ flex: 1, padding: '8px', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#94a3b8', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
              ✏️ Modifica
            </button>
            <button onClick={() => toggleAttivo(u)}
              style={{ flex: 1, padding: '8px', background: u.Attivo ? '#ef444418' : '#10b98118', border: `1px solid ${u.Attivo ? '#ef444444' : '#10b98144'}`, borderRadius: 8, color: u.Attivo ? '#ef4444' : '#10b981', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
              {u.Attivo ? '🔴 Disattiva' : '🟢 Attiva'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
